export const STATUS = {
  draft: { label: "Draft", cls: "pill-status pill-draft" },
  queued: { label: "Queued", cls: "pill-status pill-queued" },
  queued_sent: { label: "Queued", cls: "pill-status pill-queued" },
  failed: { label: "Needs attention", cls: "pill-status pill-failed" },
  sent: { label: "Pending", cls: "pill-status pill-pending" },
  viewed: { label: "In progress", cls: "pill-status pill-progress" },
  completed: { label: "Done", cls: "pill-status pill-done" },
  canceled: { label: "Canceled", cls: "pill-status pill-canceled" },
};

export const StatusPill = ({ status }) => {
  const s = STATUS[status] || STATUS.draft;
  return <span className={s.cls} data-testid={`status-pill-${status}`} data-status={status}>{s.label}</span>;
};
